import { useMutation, useQueryClient } from '@tanstack/react-query'
import APIServices from '@/api/APIServices'

const deleteShipmentNotification = async (id: number): Promise<void> => {
  await APIServices.deleteAPI(`/cargo/shippingnotification/${id}`)
}

export function useDeleteShipmentNotification() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteShipmentNotification,
    onSuccess: () => {
      // Invalidar y refrescar la cache de notificaciones
      queryClient.invalidateQueries({ queryKey: ['shipment-notifications'] })
    },
    onError: () => {
      // Error deleting shipment notification
    },
  })
}
